<template>
  <div>
    <ModuleHeader> Campañas Marketing </ModuleHeader>

    <DataTable :config="config" :data="campanas" @buttonClick="dtButtonClick" />

    <modal v-model="showModal" :key="formModal">
      <CampanasCuponesForm
        v-if="campana"
        :dataCupon="campana"
        :canjes="canjes"
      />
    </modal>
  </div>
</template>

<script>
import DataTable from "../../MainComponents/DataTable.vue";
import CampanasCuponesForm from "./CampanasCuponesForm.vue";
import modal from "../../MainComponents/modal.vue";

export default {
  name: "CampanasMarketing",
  components: {
    DataTable,
    CampanasCuponesForm,
    modal,
  },
  data() {
    return {
      campanas: [],
      canjes: [],
      subscriptores: [],
      campana: null,
      showModal: false,
      formModal: 0,
      config: {
        selectableRow: true,
        allowExport: false,
        rawText: "Campañas Marketing",
        orderByCol: {},
        selectConfig: {
          idRowData: "id",
        },
        fields: [
          { text: "Id", value: "id" },
          { text: "Nombre", value: "nom" },
          { text: "Descripción", value: "dsc" },
          { text: "Usos", value: "uss" },
          {
            title: "Estatus",
            dataName: "Activo",
            text: "Estatus",
            value: "act",
            format: (row) => {
              return row.act
                ? '<span class="green--text">Activo</span>'
                : '<span class="red--text">Inactivo</span>';
            },
          },
          {
            text: "Opciones",
            value: "idd",
            buttons: [
              {
                color: "green",
                text: "Detalles",
                buttonId: "showDetail",
                value: "id",
              },
            ],
          },
        ],
      },
    };
  },
  methods: {
    async dtButtonClick(buttonId, idSelected) {
      if (buttonId === "showDetail") {
        this.campana = null;
        const campana = this.campanas.find((item) => item.id === idSelected);
        if (!campana) return;
        try {
          await Promise.all([this.getCanjes(idSelected), this.getPrs(campana)]);
          this.campana = campana;
          this.formModal++;
          this.showModal = true;
        } catch (error) {
          console.error("Error al cargar detalles:", error);
        }
      }
    },
    async getCampanas() {
      try {
        const database = this.$store.getters.getFirebaseApp.database;
        const ref = database.ref("MKT/Campañas");
        const snapshot = await database.get(ref);
        if (snapshot.exists()) {
          this.campanas = this.$pgsHelper.ArrayObjectToArray(snapshot.val());
        }
      } catch (error) {
        console.error("Error en getCampanas:", error);
      }
    },
    async getPrs(campana) {
      // Inicializamos un objeto para agrupar los resultados
      const prs = {
        Categorias: [],
        Productos: [],
      };
      campana.prsSearched = null;
      const database = this.$store.getters.getFirebaseApp.database;
      try {
        const promises = campana.prs.map(async (item) => {
          if (item.tp === "C") {
            const ref = database.ref(`PDV/Productos/Categorias/${item.id}`);
            const snapshot = await database.get(ref);
            if (snapshot.exists()) {
              const cate = snapshot.val();
              prs.Categorias.push({ cn: item.cn, ...cate });
            }
          } else if (item.tp === "P") {
            const producto = this.getProductoById(item.id);
            if (producto) {
              prs.Productos.push({ cn: item.cn, ...producto });
            }
          }
        });
        await Promise.all(promises);
        campana.prsSearched = prs;
      } catch (error) {
        console.error("Error en getPrs:", error);
      }
    },
    getProductoById(code) {
      const producto = this.$store.getters.getProductos.find(
        (p) => p.id === code
      );
      return producto || false;
    },
    async getCanjes(id) {
      try {
        const database = this.$store.getters.getFirebaseApp.database;
        const ref = database.ref(`MKT/Canjes/${id}`);
        const snapshot = await database.get(ref);
        if (!snapshot.exists()) {
          this.canjes = [];
          return;
        }
        this.canjes = this.$pgsHelper.ArrayObjectToArray(snapshot.val());
        // Asocia cada canje con su subscritor
        this.canjes.forEach((canje) => {
          canje.sub = this.subscriptores.find(
            (sub) => sub.canjeAsociado === canje.id
          );
        });
      } catch (error) {
        console.error("Error en getCanjes:", error);
      }
    },
    async getSubscriptores() {
      try {
        const database = this.$store.getters.getFirebaseApp.database;
        const ref = database.ref("MKT/Subscriptores");
        const snapshot = await database.get(ref);
        if (snapshot.exists()) {
          this.subscriptores = this.$pgsHelper.ArrayObjectToArray(
            snapshot.val()
          );
          this.subscriptores.forEach((sub) => {
            // Verificamos si sub.Mdc existe y obtenemos la primera key
            sub.canjeAsociado = sub.Mdc ? Object.keys(sub.Mdc)[0] : null;
          });
        }
      } catch (error) {
        console.error("Error en getSubscriptores:", error);
      }
    },
  },
  async mounted() {
    try {
      await Promise.all([this.getCampanas(), this.getSubscriptores()]);
    } catch (error) {
      console.error("Error al montar el componente:", error);
    }
  },
};
</script>
